var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-cpn',{attrs:{"contract-info":_vm.contractInfo,"loading-data":_vm.loadingData},on:{"setCustomRewardToken":_vm.setCustomRewardToken,"revertToBNBReward":_vm.revertToBNBReward,"claimReward":_vm.claimReward}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }